"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function msr(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.0026 4.5C7.86262 4.5 4.50262 7.86 4.50262 12C4.50262 12.0998 4.51237 12.195 4.51762 12.2947H8.03737L9.73762 9.36975L12.0026 12.615L14.2624 9.36975L15.9626 12.2947H19.4824C19.4876 12.195 19.4974 12.0998 19.4974 12C19.5026 7.86 16.1426 4.5 12.0026 4.5ZM17.1724 11.3903C16.8679 8.805 14.6674 6.795 12.0026 6.795C9.33787 6.795 7.13737 8.81025 6.83288 11.3903H5.92237C6.22762 8.30475 8.83763 5.88975 12.0026 5.88975C15.1676 5.88975 17.7724 8.30475 18.0829 11.3903H17.1724Z", fill: color }),
        React.createElement("path", { d: "M14.1978 11.0498L12.0026 14.1998L9.80732 11.0498L8.55782 13.2001H4.60757C5.18282 16.7701 8.26757 19.5001 12.0026 19.5001C15.7376 19.5001 18.8223 16.7701 19.3976 13.1948H15.4473L14.1978 11.0498ZM16.7628 14.1001H17.7326C16.8723 16.4348 14.6328 18.1103 12.0026 18.1103C9.37232 18.1103 7.13282 16.4348 6.27257 14.1001H7.24232C8.05232 15.9248 9.87782 17.2051 12.0026 17.2051C14.1273 17.2051 15.9528 15.9248 16.7628 14.1001Z", fill: color }));
}
exports["default"] = msr;
//# sourceMappingURL=msr.js.map